import styled from 'styled-components';
import classNames from 'classnames';
import { mediaQueries } from "../../utils/device";
import { lightThemeObject } from "../../styleguide";
export var Root = styled.header.withConfig({
  displayName: "TabBarstyles__Root",
  componentId: "sc-1csy6k6-0"
})(["z-index:9100;position:relative;background-color:var(--bui-background,", ");box-shadow:0px 0px 2px 0px rgba(54,52,51,0.26);"], lightThemeObject['--bui-background']);
export var NavBar = styled.div.withConfig({
  displayName: "TabBarstyles__NavBar",
  componentId: "sc-1csy6k6-1"
})(["display:flex;align-items:center;justify-content:space-between;margin:auto;padding:0 8px 0 16px;max-width:980px;height:60px;background-color:var(--bui-background,", ");z-index:100;@media ", "{padding:0;}"], lightThemeObject['--bui-background'], mediaQueries.large);
export var Item = styled.div.attrs(function (_ref) {
  var _ref$hideOnWideScreen = _ref.hideOnWideScreens,
      hideOnWideScreens = _ref$hideOnWideScreen === void 0 ? false : _ref$hideOnWideScreen,
      _ref$hideOnNarrowScre = _ref.hideOnNarrowScreens,
      hideOnNarrowScreens = _ref$hideOnNarrowScre === void 0 ? false : _ref$hideOnNarrowScre,
      _ref$grow = _ref.grow,
      grow = _ref$grow === void 0 ? false : _ref$grow;
  return {
    className: classNames({
      grow: grow,
      hideOnNarrowScreens: hideOnNarrowScreens,
      hideOnWideScreens: hideOnWideScreens
    })
  };
}).withConfig({
  displayName: "TabBarstyles__Item",
  componentId: "sc-1csy6k6-2"
})(["&.grow{@media ", "{flex:1 1 auto;}}&.hideOnNarrowScreens{display:none;@media ", "{display:flex;}}&.hideOnWideScreens{@media ", "{display:none;}}"], mediaQueries.medium, mediaQueries.medium, mediaQueries.medium);
//# sourceMappingURL=TabBar.styles.js.map